import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useOnboardingStore } from './onboardingStore';
import { useOnboardingActions } from './OnboardingActionsContext';
import { SectionMarker } from '../components/SectionMarker';
import { FooterState } from '../components/FooterState';
const ALL_OPTIONS = [
    { value: 'u18', key: 'u18' },
    { value: '18_24', key: '18_24' },
    { value: '25_34', key: '25_34' },
    { value: '35_44', key: '35_44' },
    { value: '45_54', key: '45_54' },
    { value: '55_plus', key: '55_plus' },
];
/**
 * Onboarding step 2 — Age band (DEC-014 utility-first cyanotype).
 *
 * Themis §3.3 : age gate strict 18+. Pas de pre-coche, pas de slider
 * defaut. Si u18 : warning + CTA disabled. Le serveur Edge Function
 * validate-signup re-verifie cote backend.
 */
export function AgeBand() {
    const { t } = useTranslation('onboarding');
    const navigate = useNavigate();
    const ageBand = useOnboardingStore((s) => s.ageBand);
    const setAgeBand = useOnboardingStore((s) => s.setAgeBand);
    const { setActions } = useOnboardingActions();
    const isUnder18 = ageBand === 'u18';
    const canContinue = ageBand !== null && !isUnder18;
    useEffect(() => {
        setActions(_jsx("button", { type: "button", disabled: !canContinue, onClick: () => navigate('/onboarding/signup'), className: `
          inline-flex h-11 w-full items-center justify-center
          font-display text-[14px] font-medium tracking-[-0.02em]
          transition active:scale-[0.98]
          ${canContinue
                ? 'bg-cyan-core text-cyan-surface hover:bg-cyan-media'
                : 'cursor-not-allowed bg-cyan-text-faint/40 text-cyan-surface'}
        `, children: t('age_band.cta') }));
        return () => setActions(null);
    }, [canContinue, navigate, setActions, t]);
    return (_jsxs("article", { className: "flex flex-1 flex-col gap-5 pt-2", children: [_jsxs("header", { className: "flex flex-col gap-3", children: [_jsx(SectionMarker, { num: "02", label: t('flow.step', { current: 2, total: 4 }) }), _jsx("h1", { className: "font-display text-[28px] font-medium leading-[1.05] tracking-cy-display text-cyan-text", children: t('age_band.title') }), _jsx("p", { className: "text-[13px] font-light leading-5 text-cyan-text-secondary", children: t('age_band.body') })] }), _jsxs("fieldset", { className: "flex flex-col gap-2", children: [_jsx("legend", { className: "sr-only", children: t('age_band.title') }), ALL_OPTIONS.map(({ value, key }) => {
                        const isSelected = ageBand === value;
                        return (_jsxs("label", { className: `
                card-blueprint flex cursor-pointer items-center justify-between
                px-4 py-3
                transition
                ${isSelected ? 'border-cyan-network bg-cyan-bg' : 'hover:border-cyan-text-faint'}
              `, children: [_jsx("span", { className: "font-display text-[14px] font-medium tracking-[-0.02em] text-cyan-text", children: t(`age_band.options.${key}`) }), _jsx("input", { type: "radio", name: "ageBand", value: value ?? '', checked: isSelected, onChange: () => setAgeBand(value), className: "h-[16px] w-[16px] accent-cyan-core" })] }, key));
                    })] }), isUnder18 ? (_jsx("p", { role: "alert", className: "\n            card-blueprint border-cyan-media px-4 py-3\n            text-[13px] font-light leading-5 text-cyan-text\n          ", children: t('age_band.u18_warning') })) : null, _jsx("div", { className: "mt-auto pt-4", children: _jsx(FooterState, { state: t('flow.step', { current: 2, total: 4 }), coord: "O\u201402 \u00B7 006" }) })] }));
}
//# sourceMappingURL=AgeBand.js.map